// used for yup validation

import { array, object, string } from 'yup';

export const commNoteValidation = object({
  diagnosis: array().of(string())
    .when([ 'submit', 'comm.billable' ], {
      is: (submit: string, billable: boolean) => submit === 'now' && billable,
      then: s => s.required().min(1, 'Please add at least one diagnosis'),
      otherwise: s => s.notRequired().nullable()
    }),
  cptCodes: string()
    .when([ 'submit', 'comm.billable' ], {
      is: (submit: string, billable: boolean) => submit === 'now' && billable,
      then: s => s.nullable().required('Please select a CPT code'),
      otherwise: s => s.notRequired().nullable()
    }),
});
